// import global styles
import './styles/index.scss';
import { externalLinks } from './scripts/external-links';
import { lazyLoad } from './scripts/image-lazy-load';
import { accordion } from './scripts/accordion';
import { loadMore, LoadMoreYears, LoadMoreReviews } from './scripts/loadmoreposts';
import { cookieBannerFunct } from './scripts/cookiebanner';
import { handleAnalyticsEvents } from './scripts/analytics';
import { showControl, abTestVTwo } from './scripts/abtest';
import { navmenu } from './scripts/navmenu';
import { mobileCTAButtons } from './scripts/mobilecta';
import { blogToc } from './scripts/blog-toc';
import { personalizedCTABanner } from './scripts/cta-banner';
import { personalizationHeroBanner } from './scripts/personalization-banner';
import { highlightText } from './scripts/highlighttext';
import { addUTMParam } from './scripts/addUTMParam';
import { modalwindow } from './scripts/modalwindow';
import { popUp } from './scripts/pop-up';
import { appStoreDialog } from './scripts/app-store-dialog';
import { engagement } from './scripts/engagement';
import { oportunList } from './scripts/list'
import { articleHelpful } from './scripts/article-helpful'
import { zipSearch } from './scripts/zip-search'
import { contactFormValid, contactFormAttachment } from './scripts/contact-form';
import { handleQueryParams, queryParamSessionStorageLeadId, queryParamClientId_and_visitorId } from './scripts/queryParamsForward';
import { faq } from './scripts/faq';
import { glossary } from './scripts/glossary';
import { initSliderPagination } from './scripts/slider-block';
import { privacySettingsADA } from './scripts/privacy-settings-ada';
import { splcalc } from './scripts/splcalc';
// this module will be deferred

export default function init() {  
  // Helper function to check if variants is not empty
  function hasValidVariants(variants) {
    if (!variants) return false;
    if (Array.isArray(variants)) return variants.length > 0;
    if (typeof variants === 'object') return Object.keys(variants).length > 0;
    return false;
  }
  
  function onLoad() {
    externalLinks();
    lazyLoad();
    accordion();
    navmenu();
    personalizedCTABanner();
    loadMore();
    LoadMoreYears();
    cookieBannerFunct();
    handleAnalyticsEvents();
    LoadMoreReviews();
    blogToc();
    highlightText();
    mobileCTAButtons();
    modalwindow();
    popUp();
    appStoreDialog();
    engagement();
    oportunList();
    articleHelpful();
    zipSearch();
    contactFormValid();
    contactFormAttachment();
    handleQueryParams();
    queryParamClientId_and_visitorId();
    faq();
    glossary();
    initSliderPagination();
    privacySettingsADA();
    splcalc();
  }
  
  personalizationHeroBanner();
  if (document.readyState !== 'loading') {
    onLoad();
  } else {
    document.addEventListener('DOMContentLoaded', onLoad);
  }
  window.experimentCallback = function(){
    clearTimeout(experimentTimeOut);
    document.removeEventListener('experiment_ready', experimentCallback);
    // console.log('[ABTEST] experiment_ready received → calling abTestVTwo');
    abTestVTwo(window.OCW_ACTIVE_EXPERIMENTS && window.OCW_ACTIVE_EXPERIMENTS.variants);
    console.log('---- clear timeout ----');
  };


  if(window.OCW_ACTIVE_EXPERIMENTS && hasValidVariants(window.OCW_ACTIVE_EXPERIMENTS.variants)){
    // console.log('[ABTEST] variants already available → calling abTestVTwo immediately');
    abTestVTwo(window.OCW_ACTIVE_EXPERIMENTS.variants);
  }else{
    document.addEventListener('experiment_ready', experimentCallback );
    window.experimentTimeOut = setTimeout(function(){
      if(window.OCW_ACTIVE_EXPERIMENTS && hasValidVariants(window.OCW_ACTIVE_EXPERIMENTS.variants)){
        abTestVTwo(window.OCW_ACTIVE_EXPERIMENTS.variants);
        
      }else{
        document.dispatchEvent(new CustomEvent("experiment_timeout",{"bubbles":true,"detail": {}}));
        document.removeEventListener('experiment_ready', experimentCallback);
        showControl();
        console.log('----show control----');
      }
    },1600);
  }
}

let splCalcObserver = null;

function initSplCalcWhenAvailable() {
  const tryInit = () => {
    const element = document.querySelector('#splcalc');
    if (!element || element.dataset.splcalcInitialized === 'true') {
      return false;
    }

    splcalc();
    return true;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit, { once: true });
  } else {
    tryInit();
  }

  if (!document.body || splCalcObserver) {
    return;
  }

  splCalcObserver = new MutationObserver(() => {
    tryInit();
  });

  splCalcObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function changeLoanAmountRanges() {

  const replaceSettings = window.ocwSplSettings?.replaceSettings;

  console.log('[SPL Replace Debug]', {
    allSettings: window.ocwSplSettings,
    replaceSettings,
    hostname: window.location.hostname,
    pathname: window.location.pathname,
  });

  if (!replaceSettings || typeof replaceSettings !== 'object') {
    console.warn('[SPL Replace] Missing replace settings');
    return;
  }
  const heroImageRows = Array.isArray(
    replaceSettings.spl_replace_hero_image
  )
    ? replaceSettings.spl_replace_hero_image
    : [];

  /**
   * Normalizes paths so these values are considered equal:
   *
   * /personal-loans
   * /personal-loans/
   */
  function normalizePath(path) {
    const cleanPath = String(path || '')
      .trim()
      .split('?')[0]
      .split('#')[0];

    if (!cleanPath || cleanPath === '/') {
      return '/';
    }

    return `/${cleanPath.replace(/^\/+|\/+$/g, '')}/`;
  }

  function normalizeList(values) {
    if (!Array.isArray(values)) {
      return [];
    }

    return values
      .map((value) => String(value).trim().toUpperCase())
      .filter(Boolean);
  }

  function normalizeValues(value, transform = (item) => item) {
    let values = [];

    if (Array.isArray(value)) {
      values = value;
    } else if (typeof value === 'string') {
      values = value.split(/[\r\n,]+/);
    }

    return values
      .map((item) => transform(String(item).trim()))
      .filter(Boolean);
  }

  const activePath = normalizePath(window.location.pathname);
  const targetPaths = normalizeValues(
    replaceSettings.spl_replace_target_paths,
    normalizePath
  );

  if (!targetPaths.includes(activePath)) {
    console.info('[SPL Replace] Path not enabled', { activePath });
    return;
  }
  /*
   * Production is oportun.com.
   * Every other hostname is treated as non-production.
   */
  const hostname = window.location.hostname.toLowerCase();

  const isProduction =
  hostname === 'oportun.com' ||
  hostname === 'www.oportun.com';

  const currentEnvironment = isProduction
    ? 'production'
    : 'non-production';

  const targetEnvironments = normalizeValues(
    replaceSettings.spl_replace_target_environments,
    (environment) => environment.toLowerCase()
  );



  if (
    targetEnvironments.length === 0 ||
    !targetEnvironments.includes(currentEnvironment)
  ) {
    console.warn('[SPL Replace] Environment not enabled');
    return;
  }

  const liveStates = normalizeValues(
    replaceSettings.spl_replace_state_list,
    (state) => state.toUpperCase()
  );

  const testingStates = normalizeValues(
    replaceSettings.spl_replace_testing_states,
    (state) => state.toUpperCase()
  );

  const availableStates = isProduction
    ? liveStates
    : [...new Set([...liveStates, ...testingStates])];

  console.log('[SPL Replace] State configuration', {
    liveStates,
    testingStates,
    availableStates,
  });

  function getImageUrl(imageField) {
    if (typeof imageField === 'string') {
      return imageField.trim();
    }

    if (
      imageField &&
      typeof imageField === 'object' &&
      typeof imageField.url === 'string'
    ) {
      return imageField.url.trim();
    }

    return '';
  }

  function waitForUtagObj({
    timeoutMs = 2000,
    intervalMs = 100,
  } = {}) {
    return new Promise((resolve) => {
      const startTime = performance.now();
      let attempts = 0;

      const tick = () => {
        attempts++;

        const visitorStateLocation =
          window.utag_data &&
          typeof window.utag_data.visitor_state_location !== 'undefined'
            ? window.utag_data.visitor_state_location
            : null;

        if (visitorStateLocation) {
          const elapsedMs = performance.now() - startTime;

          console.info(
            '[Tealium] visitor_state_location found',
            {
              elapsedMs: Math.round(elapsedMs),
              attempts,
              visitor_state_location: visitorStateLocation,
            }
          );

          resolve({
            visitor_state_location: visitorStateLocation,
            elapsedMs,
            attempts,
            timedOut: false,
          });

          return;
        }

        if (performance.now() - startTime >= timeoutMs) {
          const elapsedMs = performance.now() - startTime;

          console.warn(
            '[Tealium] visitor_state_location timeout',
            {
              elapsedMs: Math.round(elapsedMs),
              attempts,
            }
          );

          resolve({
            visitor_state_location: null,
            elapsedMs,
            attempts,
            timedOut: true,
          });

          return;
        }

        window.setTimeout(tick, intervalMs);
      };

      tick();
    });
  }

  const toFind = /\$300\s*(a|hasta|to)\s*\$10,000/g;
  const toFindTwo = /\$300\s*(a|hasta|to)\s*\$10,001/g;

  const observerLifetimeMs = 10000;

  function isInsideExcludedElement(node) {
    if (!node) {
      return false;
    }

    const element =
      node.nodeType === Node.ELEMENT_NODE
        ? node
        : node.parentElement;

    return Boolean(
      element?.closest('oportun-list-item, div#splcalc')
    );
  }

  function nodeMayContainTarget(node) {
    if (!node || isInsideExcludedElement(node)) {
      return false;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      return (
        typeof node.textContent === 'string' &&
        node.textContent.includes('$300')
      );
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    if (
      node.tagName === 'SCRIPT' ||
      node.tagName === 'STYLE'
    ) {
      return false;
    }

    return (
      typeof node.textContent === 'string' &&
      node.textContent.includes('$300')
    );
  }

  function processNode(node) {
    if (!nodeMayContainTarget(node)) {
      return false;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const originalText = node.textContent;

      node.textContent = node.textContent
        .replace(
          toFind,
          (_, connector) => `$300 ${connector} $18,500`
        )
        .replace(
          toFindTwo,
          (_, connector) => `$300 ${connector} $10,000`
        );

      return node.textContent !== originalText;
    }

    const walker = document.createTreeWalker(
      node,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(textNode) {
          if (isInsideExcludedElement(textNode)) {
            return NodeFilter.FILTER_REJECT;
          }

          return nodeMayContainTarget(textNode)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        },
      }
    );

    let changed = false;
    let textNode = walker.nextNode();

    while (textNode) {
      const originalText = textNode.textContent;

      textNode.textContent = textNode.textContent
        .replace(
          toFind,
          (_, connector) => `$300 ${connector} $18,500`
        )
        .replace(
          toFindTwo,
          (_, connector) => `$300 ${connector} $10,000`
        );

      if (textNode.textContent !== originalText) {
        changed = true;
      }

      textNode = walker.nextNode();
    }

    return changed;
  }

  const newImageUrl =
    window.location.origin +
    '/wp-content/uploads/2026/05/Group-6426_oportun.png';

  const newPLImageUrl =
    window.location.origin +
    '/wp-content/uploads/2026/05/Oportun-personal-loans-spl-range.png';

  const newImageES =
    window.location.origin +
    '/wp-content/uploads/2026/07/Oportun_hero_image_loan_range_ES.png';


  function replaceHeroImage() {
    const heroSection = document.querySelector('.Hero');

    if (!heroSection || isInsideExcludedElement(heroSection)) {
      return false;
    }

    const currentPath = normalizePath(window.location.pathname);

    const matchingRow = heroImageRows.find((row) => {
      if (!row || typeof row !== 'object') {
        return false;
      }

      const rowPath = normalizePath(row.replace_url_path);

      return rowPath === currentPath;
    });

    if (!matchingRow) {
      return false;
    }

    const heroImageUrl = getImageUrl(matchingRow.image);

    if (!heroImageUrl) {
      return false;
    }

    const imageContainer = heroSection.querySelector('.image');

    if (!imageContainer) {
      return false;
    }

    const picture = imageContainer.querySelector('picture');
    let changed = false;

    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        if (source.getAttribute('srcset') !== heroImageUrl) {
          source.setAttribute('srcset', heroImageUrl);
          changed = true;
        }
      });
    }

    const img = picture
      ? picture.querySelector('img')
      : imageContainer.querySelector('img');

    if (img) {
      if (img.getAttribute('src') !== heroImageUrl) {
        img.setAttribute('src', heroImageUrl);
        changed = true;
      }

      /*
      * Remove the old responsive image candidates so the browser
      * does not select a previous image from srcset.
      */
      if (img.hasAttribute('srcset')) {
        img.removeAttribute('srcset');
        changed = true;
      }

      if (img.hasAttribute('sizes')) {
        img.removeAttribute('sizes');
        changed = true;
      }
    }

    if (
      imageContainer.style.getPropertyValue('--image-aspect') !== '0'
    ) {
      imageContainer.style.setProperty('--image-aspect', '0');
      changed = true;
    }

    return changed;
  }

  function changeLoanCalculatorAmount() {
    const loanCalc = document.querySelector(
      'oportun-loan-calculator'
    );

    if (!loanCalc || !loanCalc.shadowRoot) {
      return false;
    }

    const calculator = loanCalc.shadowRoot.querySelector(
      'oportun-calculator'
    );

    if (!calculator || !calculator.shadowRoot) {
      return false;
    }

    let changed = false;

    calculator.shadowRoot
      .querySelectorAll(
        '.amount-container-preselect > .current_amount'
      )
      .forEach((element) => {
        if (element.textContent.includes('$10,000')) {
          element.textContent =
            element.textContent.replace(
              '$10,000',
              '$18,500'
            );

          changed = true;
        }
      });

    return changed;
  }

  function initHeroAndCalculatorChanges() {
    function onCalculatorReady(loanCalcElement) {
      replaceHeroImage();
      changeLoanCalculatorAmount();

      function tryObserveCalculatorShadow() {
        if (!loanCalcElement.shadowRoot) {
          return false;
        }

        const calculator =
          loanCalcElement.shadowRoot.querySelector(
            'oportun-calculator'
          );

        if (!calculator || !calculator.shadowRoot) {
          return false;
        }

        const shadowObserver = new MutationObserver(() => {
          changeLoanCalculatorAmount();
        });

        shadowObserver.observe(calculator.shadowRoot, {
          childList: true,
          subtree: true,
        });

        window.setTimeout(
          () => shadowObserver.disconnect(),
          observerLifetimeMs
        );

        return true;
      }

      if (!tryObserveCalculatorShadow()) {
        const shadowReadyObserver =
          new MutationObserver(() => {
            if (tryObserveCalculatorShadow()) {
              shadowReadyObserver.disconnect();
            }
          });

        shadowReadyObserver.observe(loanCalcElement, {
          childList: true,
          subtree: true,
        });

        window.setTimeout(
          () => shadowReadyObserver.disconnect(),
          observerLifetimeMs
        );
      }
    }

    const existing = document.querySelector(
      'oportun-loan-calculator'
    );

    if (existing) {
      onCalculatorReady(existing);
      return;
    }

    const observer = new MutationObserver(() => {
      const element = document.querySelector(
        'oportun-loan-calculator'
      );

      if (!element) {
        return;
      }

      observer.disconnect();
      onCalculatorReady(element);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(
      () => observer.disconnect(),
      observerLifetimeMs
    );
  }

  waitForUtagObj().then((result) => {
    const state = String(
      result.visitor_state_location || ''
    )
      .trim()
      .toUpperCase();

    if (!state || !availableStates.includes(state)) {
      return;
    }

    processNode(document.body);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          processNode(node);
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(
      () => observer.disconnect(),
      observerLifetimeMs
    );

    initHeroAndCalculatorChanges();
  });
}

init();
initSplCalcWhenAvailable();
/** 
 * uncomment this section when needed
 * this is in charge of  replace image, and loan ranges based on the state
 * improvement for next release:
 * - create ACF option page to turn on and off this function
 * - under the same ACF, add the range of values when change
*/
changeLoanAmountRanges();